import React, {Component} from 'react';
import {withRouter} from 'react-router';
import {Route, useHistory} from 'react-router-dom';
import {connect} from 'react-redux';
import {message, Modal, Spin} from "antd";
import * as api from "./services";
import {createHashHistory} from 'history';
import {LoadingOutlined} from '@ant-design/icons';
import './index.less'

const antIcon = <LoadingOutlined style={{fontSize: 48}} spin/>;

const history = createHashHistory();

class AuthorizedRoute extends Component {
    constructor(props) {
        super(props)

        this.state = {
            count: 1,
            isTrucAction: null
        }
    }


    render() {
        const {component: Component, ...rest} = this.props;
        return (
            <Route {...rest} render={props => {
                return <Component {...props} />
            }}/>
        );
    }
}

const stateToProps = (state) => {
    return {...state.LoginReducer}
};
const dispatchToProps = (dispatch) => ({
    loginIn() {
        dispatch({
            type: 'loginIn',
            payload: {
                islogin: true
            }
        });
    },
    backLogin() {
        dispatch({
            type: 'backLogin',
            payload: {
                islogin: false
            }
        });
    },
    setHeader(userName, roleId) {
        dispatch({
            type: 'loginSetPersonInfo',
            payload: {
                info: {
                    userName, roleId
                }
            }
        });
    }
});

export default connect(stateToProps, dispatchToProps)(withRouter(AuthorizedRoute));
